function normalizeRows(rows = [], type) {
  if (!Array.isArray(rows)) return [];

  return rows.map((row, index) => {
    const safeRow = typeof row === "object" && row !== null ? row : {};

    const meta =
      typeof safeRow.meta === "object" && safeRow.meta !== null
        ? safeRow.meta
        : {};

    const flags =
      typeof safeRow.flags === "object" && safeRow.flags !== null
        ? safeRow.flags
        : {};

    const quantity = Number(
      safeRow.quantity ?? safeRow.qty ?? safeRow.hours ?? 0
    );

    const unitPrice = Number(
      safeRow.unitPrice ??
        safeRow.price ??
        safeRow.hourlyRate ??
        safeRow.rate ??
        0
    );

    const total =
      safeRow.total !== undefined
        ? Number(safeRow.total || 0)
        : quantity * unitPrice;

    const inactive = Boolean(
      safeRow.inactive === true ||
        safeRow.excluded === true ||
        flags.inactive === true ||
        flags.excluded === true ||
        meta.inactive === true ||
        meta.excluded === true
    );

    const inactiveReason =
      safeRow.inactiveReason ||
      safeRow.exclusionReason ||
      flags.inactiveReason ||
      flags.exclusionReason ||
      meta.inactiveReason ||
      meta.exclusionReason ||
      "";

    const label = safeRow.label || safeRow.name || "Untitled row";

    return {
      ...safeRow,

      id: safeRow.id || `${type}_${index + 1}`,
      type: safeRow.type || type,

      label,
      name: label,

      quantity,
      unitPrice,
      total,
      unit: safeRow.unit || "",

      active: !inactive,
      inactive,

      // Backend compatibility
      excluded: inactive,
      exclusionReason: inactiveReason,
      inactiveReason,

      flags: {
        ...flags,
        active: !inactive,
        inactive,
        excluded: inactive,
        exclusionReason: inactiveReason,
        inactiveReason,
      },

      meta: {
        ...meta,
        active: !inactive,
        inactive,
        excluded: inactive,
        exclusionReason: inactiveReason,
        inactiveReason,
      },

      reviewRequired: Boolean(
        safeRow.reviewRequired || flags.reviewRequired || meta.review
      ),

      materialLibraryMatch:
        safeRow.materialLibraryMatch !== undefined
          ? safeRow.materialLibraryMatch
          : meta.materialLibraryMatch !== undefined
          ? meta.materialLibraryMatch
          : undefined,

      labourRuleMatch:
        safeRow.labourRuleMatch !== undefined
          ? safeRow.labourRuleMatch
          : meta.labourRuleActivity !== undefined
          ? meta.labourRuleActivity
          : undefined,
    };
  });
}

export function normalizeEstimate(estimate = {}) {
  const safeEstimate =
    typeof estimate === "object" && estimate !== null ? estimate : {};

  const materials = normalizeRows(safeEstimate.materials, "material");
  const labour = normalizeRows(safeEstimate.labour, "labour");
  const extras = normalizeRows(safeEstimate.extras, "extra");

  return {
    ...safeEstimate,
    materials,
    labour,
    extras,
    meta: {
      ...(safeEstimate.meta || {}),
    },
    summary: {
      ...(safeEstimate.summary || {}),
      marginPercent:
        safeEstimate.summary?.marginPercent ??
        safeEstimate.meta?.marginPercent ??
        25,
    },
  };
}